var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Window",
    {
      attrs: {
        title: _vm.title,
        id: "feature-info",
        modal: "",
        maxWidth: "70%",
        fixedSize: "",
      },
      on: {
        onClose: function ($event) {
          return _vm.close("close")
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "feature-info-content" },
        _vm._l(_vm.categorizedProperties, function (categoryProps, category) {
          return Object.keys(categoryProps).length > 0
            ? _c("div", { key: category, staticClass: "category-section" }, [
                _c("h3", { staticClass: "category-title" }, [
                  _vm._v(_vm._s(category)),
                ]),
                _vm._v(" "),
                _c(
                  "table",
                  { staticClass: "properties-table" },
                  _vm._l(categoryProps, function (value, key) {
                    return _c("tr", { key: key }, [
                      _c("td", { staticClass: "property-name" }, [
                        _vm._v(_vm._s(key)),
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticClass: "property-value" },
                        [
                          value === null || value === undefined
                            ? _c("div", { staticClass: "empty-value" }, [
                                _c("i", [_vm._v("(Empty)")]),
                              ])
                            : _vm.isDateString(value)
                            ? _c("div", { staticClass: "date-value" }, [
                                _vm._v(_vm._s(_vm.formatDate(value))),
                              ])
                            : _vm.isComplex(value)
                            ? _c("ObjTable", {
                                attrs: { obj: _vm.parseComplexValue(value) },
                              })
                            : _c("div", { staticClass: "plain-value" }, [
                                _vm._v(_vm._s(value)),
                              ]),
                        ],
                        1
                      ),
                    ])
                  }),
                  0
                ),
              ])
            : _vm._e()
        }),
        0
      ),
      _vm._v(" "),
      _c("div", { staticClass: "buttons" }, [
        _c(
          "button",
          {
            staticClass: "ui button",
            on: {
              click: function ($event) {
                return _vm.close("close")
              },
            },
          },
          [_vm._v("\n            Close\n        ")]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }